import { createAuthClient } from "@neondatabase/neon-js/auth";

const authUrl = import.meta.env.VITE_NEON_AUTH_URL as string | undefined;
const authClient = authUrl ? createAuthClient(authUrl) : null;

export type AuthSession = {
  user: { id: string; name: string; email: string; emailVerified: boolean };
  session: { id: string; token: string; expiresAt: Date };
};

const requireClient = () => {
  if (!authClient)
    throw new Error("Neon Auth is not configured for this deployment.");
  return authClient;
};

export async function getSession(): Promise<AuthSession | null> {
  const client = requireClient();
  const { data, error } = await client.getSession();
  if (error)
    throw new Error(error.message ?? "Unable to read the current session.");
  return data as AuthSession | null;
}

export async function signIn(email: string, password: string) {
  const { error } = await requireClient().signIn.email({ email, password });
  if (error) throw new Error(error.message ?? "Unable to sign in.");
  return getSession();
}

export async function signUp(name: string, email: string, password: string) {
  const { error } = await requireClient().signUp.email({
    name,
    email,
    password,
  });
  if (error) throw new Error(error.message ?? "Unable to create your account.");
  return getSession();
}

export async function signOut() {
  const { error } = await requireClient().signOut();
  if (error) throw new Error(error.message ?? "Unable to sign out.");
}

export const isAuthConfigured = Boolean(authUrl);
